import { render, staticRenderFns } from "./JobBacklogTable.vue?vue&type=template&id=14847aa0&"
import script from "./JobBacklogTable.vue?vue&type=script&lang=js&"
export * from "./JobBacklogTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports